<template>
    <div class="tab-group">
        <ul class="tab-group__tabs">
            <li v-for="(tab, idx) in tabs"
                :key="`tab_${idx}`"
                class="tab-group__tabs__item"
                :class="{
                    'tab-group__tabs__item--active': tab.active,
                }"
                tabindex="0"
                @keypress.enter="activate(tab)"
                @keypress.space.prevent="activate(tab)"
                @click="activate(tab)">
                <slot name="tab" :tab="tab">
                    {{ tab.title }}
                </slot>
            </li>
        </ul>
        <div class="tab-group__content">
            <slot />
        </div>
    </div>
</template>

<script>

export default {
    props: {
        active: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            /**
             * @type {Array<VueComponent>}
             */
            tabs: [],
        }
    },

    mounted() {
        this.tabs = this.$slots.default.map(vnode => vnode.componentInstance)

        if (this.active) {
            for (let i = 0, len = this.tabs.length; i < len; ++i) {
                if (this.tabs[i].title === this.active) {
                    this.tabs[i].active = true
                    break
                }
            }
        } else {
            this.tabs[0].active = true
        }
    },

    watch: {
        active(newValue) {
            for (let i = 0, len = this.tabs.length; i < len; ++i) {
                const currentActive = this.tabs[i].active

                this.tabs[i].active = this.tabs[i].title === newValue

                if (!currentActive && this.tabs[i].active)
                    this.$emit('activate', this.tabs[i])
            }
        },
    },

    methods: {
        /**
         * @type {VueComponent} tab
         */
        activate(tab) {
            if (!tab.canChange(tab)) return

            this.tabs.forEach(child => {
                child.active = child === tab

                if (child.active)
                    this.$emit('activate', tab)
            })
        },
    },
}

</script>

<style lang="scss">

.tab-group {
    display: block;
    width: 100%;

    @include bp-min-mid {
        display: grid;
        grid-template-columns: 1fr 3fr;
        gap: $wide-gutter;
    }

    @include element('tabs') {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(7, 1fr);

        @include bp-min-mid {
            display: block;
        }

        @include element('item') {
            display: inline-block;
            cursor: pointer;
            padding: 0.2rem;
            justify-self: center;

            @include bp-min-mid {
                display: block;
                padding: 0.7rem 0.7rem 0.7rem 1rem;
            }
        }
    }

    @include element('content') {
        padding-top: 0.7rem;
    }
}

</style>
